import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProviderRow, SentRow, ProviderType } from "namirasoft-sms-sender";
import { SMSSenderRoutes } from "./SMSSenderRoutes";
import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, IntegerFormatter, PhoneFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { SMSSenderMenus } from "./SMSSenderMenus";
import { SMSSenderProps } from "./SMSSenderProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class SMSSenderEntities
{
	static provider(props: NSARouterMakerResult & SMSSenderProps): IEntityInfo<ProviderRow, ProviderRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_SMS_SENDER,
			name: "provider",
			tables: [{ table: namirasoft.sms_sender.tables.provider, required: true }],
			client: {
				getColumns()
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.type, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.p_verified, new ForeColorFormatter(new BooleanFormatter("Verified", "Not Yet"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.limit, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.limit_count, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.limit_per_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.limit_per_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.delay, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.delay_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.delay_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.provider.columns.updated_at, new DateTimeFormatter()),
					]
				},
				getListURL: () => SMSSenderRoutes.ProviderList,
				getNewURL: () => SMSSenderRoutes.ProviderNew,
				getCopyURL: (id: string) => SMSSenderRoutes.ProviderCopy(id),
				getEditURL: (id: string) => SMSSenderRoutes.ProviderEdit(id),
				getViewURL: (id: string) => SMSSenderRoutes.ProviderView(id),
				onCreate: async (entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.p_verified;
					delete body.meta;
					delete body.created_at;
					delete body.updated_at;
					if (entity.type === ProviderType.AWS)
						return await props.servers.sms_sender.aws.Create(body);
					throw new Error("Wrong provider type");
				},
				onUpdate: async (id, entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.p_verified;
					delete body.meta;
					delete body.created_at;
					delete body.updated_at;
					if (entity.type === ProviderType.AWS)
						return await props.servers.sms_sender.aws.Update(id, body);
					throw new Error("Wrong provider type");
				},
				getMenus: (getIDs, getRows) => { return { "Provider": [SMSSenderMenus.verify(getIDs, getRows), SMSSenderMenus.send(getIDs, getRows)] } },
				onSuccess: (entity) =>
				{
					props.url.redirect(SMSSenderRoutes.Verify(entity.id), {});
					return true;
				}
			},
			server: {
				value_list: props.servers.sms_sender.value.List,
				get: props.servers.sms_sender.provider.Get,
				list: props.servers.sms_sender.provider.List,
				create: async (entity) =>
				{
					let body = {
						workspace_id: entity.workspace_id,
						name: entity.name,
						region: entity.meta.region,
						access_key: entity.meta.access_key,
						secret_key: entity.meta.secret_key,
						limit: entity.limit,
						limit_count: entity.limit_count,
						limit_per_value: entity.limit_per_value,
						limit_per_unit: entity.limit_per_unit,
						delay: entity.delay,
						delay_value: entity.delay_value,
						delay_unit: entity.delay_unit,
						description: entity.description,
						provider_category: [], provider_field: [], provider_tag: [],
					}
					if (entity.type === ProviderType.AWS)
						return await props.servers.sms_sender.aws.Create(body);
					throw new Error("Wrong provider type");
				},
				update: async (id, entity) =>
				{
					if (entity.type === ProviderType.AWS)
					{
						let body = {
							reset_verified: null,
							workspace_id: entity.workspace_id,
							name: entity.name,
							region: entity.meta.region,
							access_key: entity.meta.access_key,
							secret_key: entity.meta.secret_key,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						}
						return await props.servers.sms_sender.aws.Update(id, body);
					}
					throw new Error("Wrong provider type");
				},
				delete: props.servers.sms_sender.provider.Delete
			}
		};
	}
	static sent(props: NSARouterMakerResult & SMSSenderProps): IEntityInfo<SentRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_SMS_SENDER,
			name: "sent",
			tables: [{ table: namirasoft.sms_sender.tables.sent, required: true }],
			client: {
				getColumns()
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.session_id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.provider_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.phone, new PhoneFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.successful, new ForeColorFormatter(new BooleanFormatter("Successful", "Failed"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.result, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.sms_sender.tables.sent.columns.sent_at, new DateTimeFormatter()),
					];
				},
				getListURL: () => SMSSenderRoutes.ProviderList,
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getViewURL: null,
			},
			server: {
				value_list: props.servers.sms_sender.value.List,
				get: props.servers.sms_sender.sent.Get,
				list: props.servers.sms_sender.sent.List,
				create: null,
				update: null,
				delete: null,
			}
		};
	}
}